export default __webpack_public_path__ + "static/media/2026_April_Raum.367d8ebe.webp";